(function () {
  var DESKTOP_MQ = window.matchMedia('(min-width: 1024px)');

  var ROW_HEIGHTS = [287, 287, 345, 400, 275, 287, 287];

  var MASONRY_SLOTS = [
    { col: '1 / span 6', row: '1 / span 2' },
    { col: '7 / span 3', row: '1' },
    { col: '10 / span 3', row: '1' },
    { col: '7 / span 6', row: '2' },
    { col: '1 / span 4', row: '3' },
    { col: '5 / span 4', row: '3' },
    { col: '9 / span 4', row: '3' },
    { col: '1 / span 6', row: '4' },
    { col: '7 / span 6', row: '4' },
    { col: '1 / span 3', row: '5' },
    { col: '4 / span 3', row: '5' },
    { col: '7 / span 3', row: '5' },
    { col: '10 / span 3', row: '5' },
    { col: '1 / span 6', row: '6 / span 2' },
    { col: '7 / span 3', row: '6' },
    { col: '10 / span 3', row: '6' },
    { col: '7 / span 3', row: '7' }
  ];

  var CTA_SLOT = { col: '10 / span 3', row: '7' };
  var CYCLE_ROWS = ROW_HEIGHTS.length;

  function offsetRow(row, offset) {
    var parts = row.split('/');
    var start = parseInt(parts[0], 10) + offset;
    if (parts.length === 1) {
      return String(start);
    }
    return start + ' / ' + parts[1].trim();
  }

  function slotForIndex(index) {
    var cycle = Math.floor(index / MASONRY_SLOTS.length);
    var slot = MASONRY_SLOTS[index % MASONRY_SLOTS.length];
    if (cycle === 0) {
      return slot;
    }
    return {
      col: slot.col,
      row: offsetRow(slot.row, cycle * CYCLE_ROWS)
    };
  }

  function parseRowEnd(row) {
    var parts = row.split('/').map(function (part) {
      return part.trim();
    });
    var start = parseInt(parts[0], 10);
    if (parts.length === 1) {
      return start;
    }
    var spanMatch = parts[1].match(/span\s+(\d+)/);
    var span = spanMatch ? parseInt(spanMatch[1], 10) : 1;
    return start + span - 1;
  }

  function applySlot(item, slot) {
    item.style.gridColumn = slot.col;
    item.style.gridRow = slot.row;
  }

  function clearSlot(item) {
    item.style.gridColumn = '';
    item.style.gridRow = '';
  }

  function layoutMasonryGrid(grid) {
    var imageItems = Array.prototype.slice.call(
      grid.querySelectorAll('.rng-masonry-item:not([data-rng-masonry-cta])')
    );
    var ctaItem = grid.querySelector('[data-rng-masonry-cta]');
    var imageCount = imageItems.length;
    var maxRow = 0;

    if (!DESKTOP_MQ.matches) {
      grid.style.gridTemplateRows = '';
      imageItems.forEach(clearSlot);
      if (ctaItem) {
        clearSlot(ctaItem);
      }
      return;
    }

    imageItems.forEach(function (item, index) {
      var slot = slotForIndex(index);
      applySlot(item, slot);
      maxRow = Math.max(maxRow, parseRowEnd(slot.row));
    });

    if (ctaItem) {
      var ctaSlot =
        imageCount === 17 ? CTA_SLOT : slotForIndex(imageCount);
      applySlot(ctaItem, ctaSlot);
      maxRow = Math.max(maxRow, parseRowEnd(ctaSlot.row));
    }

    if (maxRow > 0) {
      var rows = [];
      var rowIndex;
      for (rowIndex = 0; rowIndex < maxRow; rowIndex += 1) {
        rows.push(ROW_HEIGHTS[rowIndex % ROW_HEIGHTS.length] + 'px');
      }
      grid.style.gridTemplateRows = rows.join(' ');
    } else {
      grid.style.gridTemplateRows = '';
    }
  }

  function initMasonryGallery(section) {
    var galleryId = 'rng-masonry-' + section.dataset.sectionId;
    var links = section.querySelectorAll('[data-fancybox="' + galleryId + '"]');
    var openBtn = section.querySelector('[data-rng-masonry-open]');
    var grid = section.querySelector('.rng-masonry-grid');

    if (grid) {
      layoutMasonryGrid(grid);

      if (!grid.dataset.rngMasonryLayoutBound) {
        grid.dataset.rngMasonryLayoutBound = 'true';

        var resizeTimer;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            layoutMasonryGrid(grid);
          }, 150);
        });

        if (typeof DESKTOP_MQ.addEventListener === 'function') {
          DESKTOP_MQ.addEventListener('change', function () {
            layoutMasonryGrid(grid);
          });
        } else if (typeof DESKTOP_MQ.addListener === 'function') {
          DESKTOP_MQ.addListener(function () {
            layoutMasonryGrid(grid);
          });
        }
      }
    }

    if (typeof Fancybox !== 'undefined' && links.length) {
      Fancybox.bind(links, {
        groupAll: true,
        animated: true,
        dragToClose: true,
        placeFocusBack: false
      });
    }

    if (openBtn && links.length) {
      openBtn.addEventListener('click', function () {
        links[0].click();
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-rng-masonry-gallery]').forEach(initMasonryGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.matches('[data-rng-masonry-gallery]')) {
      initMasonryGallery(event.target);
    }
  });
})();
